var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBroadcastBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z",
    stroke: "#0688FA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2398 7.75969C16.7977 8.31693 17.2402 8.97866 17.5422 9.70705C17.8441 10.4354 17.9995 11.2162 17.9995 12.0047C17.9995 12.7932 17.8441 13.5739 17.5422 14.3023C17.2402 15.0307 16.7977 15.6924 16.2398 16.2497M7.75982 16.2397C7.20196 15.6824 6.75941 15.0207 6.45746 14.2923C6.15551 13.5639 6.0001 12.7832 6.0001 11.9947C6.0001 11.2062 6.15551 10.4254 6.45746 9.69705C6.75941 8.96866 7.20196 8.30693 7.75982 7.74969M19.0698 4.92969C20.9445 6.80496 21.9977 9.34805 21.9977 11.9997C21.9977 14.6513 20.9445 17.1944 19.0698 19.0697M4.92982 19.0697C3.05511 17.1944 2.00195 14.6513 2.00195 11.9997C2.00195 9.34805 3.05511 6.80496 4.92982 4.92969",
    stroke: "#0688FA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroadcastBlue);
export default __webpack_public_path__ + "static/media/broadcast-blue.50024d99b6d295b579f18d2eaaafb3a8.svg";
export { ForwardRef as ReactComponent };